<template>
  <R3Title title="Reporting ❯ Tank History"></R3Title> <!-- unicode U+276F : ❯ -->
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>
  <div style="margin-left: 40px; margin-right: 50px; width: 90%; max-width: 80%;">
    <div style="font-size: 24px;"> {{ currentContainer.containerName }} </div>
    <div v-html="subtitle" style=""></div>
    
    <DxBox :height="50" direction="row" width="100%" class="tb">
      <DxItem :ratio="0" :base-size="400">
        <DxButtonGroup :items="rangeGroup" :selected-item-keys="['30']" key-expr="range" styling-mode="outline"
          @item-click="rangeDaysChange" />
      </DxItem>
      <!-- <DxItem :ratio="0" :base-size="60">
        <div>Details</div>
        <DxSwitch v-model:value="volViewDetail" @value-changed="changeVolView" label="Hourly" />
      </DxItem> -->
      <DxItem :ratio="0" :base-size="400">
        <DateRangePicker v-model="customDateRange" :visible="showPicker" @error:invalid-range="handleInvalidRange" />
      </DxItem>
      <DxItem :ratio="0" :base-size="120">
        <DxButton v-if="showPicker" text="Apply" @click="applyCustomDateRange" icon="check" type="default"
          class="apply-button" />
      </DxItem>
    </DxBox>
    <br />
    <br />
    <br />
    <div v-if="currentContainer">
      <R3GraphHistoryVolume 
        :containerId="currentRecordId" 
        :container="currentContainer" 
        :range-days="rangeDays"
        :vol-view-detail="volViewDetail" 
      />
    </div>
    <br />
    <br />
    <br />
    <div v-if="currentContainer">
      <R3GraphHistoryInjection 
        :containerId="currentRecordId" 
        :container="currentContainer" 
        :range-days="rangeDays"
        :vol-view-detail="volViewDetail" 
      />
    </div>
    <br />
    <br />
    <br />
    <div v-if="currentContainer && !isOperator" >
      <R3GraphHistoryFill 
        :containerId="currentRecordId"
        :container="currentContainer" 
        :range-days="rangeDays"
        :vol-view-detail="volViewDetail" 
      />
      <br />
      <br />
      <br />
      <!-- <R3GraphHistoryFillX 
        :containerId="currentRecordId"
        :container="currentContainer" 
        :range-days="rangeDays"
        :vol-view-detail="volViewDetail" 
      /> -->
    </div>
    <br />
    <br />
    <br />
    <div v-if="currentContainer && !isOperator">
      <DxDataGrid class="dx-card wide-card" :data-source="currentHistory" :hover-state-enabled="true"
        :selection="{ mode: 'single' }" :show-borders="true" :columns-auto-width="false" :column-min-width="50"
        :allow-column-resizing="true" :column-resizing-mode="currentMode" :allow-column-reordering="true"
        no-data-text="Loading ..." @selection-changed="masterSelectionChanged" @row-click="dataRowToggle"
        @initialized="saveGridInstance">
        <DxStateStoring :enabled="true" type="localStorage" storage-key="rep_container_history_single" />
        <DxExport :enabled="true" />
        <DxColumnChooser :enabled="true" mode="select" />
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />

        <DxColumn data-field="containerId" :visible="false" :show-in-column-chooser="false" />
        <DxColumn data-field="historyDateUnix" :visible="false" :show-in-column-chooser="false" />
        <DxColumn data-field="containerName" caption="Name" min-width="125" />
        <DxColumn data-field="Downhole LSD" caption="Downhole LSD" min-width="125" />
        <DxColumn data-field="historyDate" caption="Date" min-width="125" />
        <DxColumn data-field="DTE" caption="DTE" min-width="125" />
        <DxColumn data-field="Product" caption="Product" min-width="125" />
        <DxColumn data-field="Volume (%)" caption="Volume (%)" min-width="125" />
        <DxColumn data-field="Volume (L)" caption="Vol (L)" min-width="125" />
        <DxColumn data-field="Volume (cm)" caption="Volume (cm)" min-width="125" />
        <DxColumn data-field="Injection Avg" caption="Injection" min-width="125" />
        <DxColumn data-field="Injection Target" caption="Injection Target" min-width="125" />
      </DxDataGrid>
    </div>
    
  </div>
  
  <DxLoadPanel v-model:visible="loadingVisible" :message="Loading" :show-indicator="true" :show-pane="true"
    :shading="true" :hide-on-outside-click="false" :on-shown="onLoadPanelShown" :on-hidden="onLoadPanelHidden"
    shading-color="rgba(0,0,0,0.4)" />

  <DxToast v-model:visible="toastVisible" v-model:message="toastMessage" v-model:type="toastType"
    position="bottom center" />
  </div>
</template>

<script>

import R3Title from "@/components/base/page-title.vue";

import R3GraphHistoryVolume from "@/components/container/graphs/graph-history-volume.vue";
import R3GraphHistoryInjection from "@/components/container/graphs/graph-history-injection.vue";
import R3GraphHistoryFillX from "@/components/container/graphs/graph-history-fill-lastX.vue";
import R3GraphHistoryFill from "@/components/container/graphs/graph-history-fill.vue";

import { DxToolbar, DxItem as DxToolbarItem } from "devextreme-vue/toolbar";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxFilterRow,
  DxColumnChooser,
  DxStateStoring,
  DxExport
} from "devextreme-vue/data-grid";
import { DxButton } from "devextreme-vue/button";
import DxButtonGroup from "devextreme-vue/button-group";
import { DxBox, DxItem } from "devextreme-vue/box";
import DateRangePicker from "@/components/custom/date-range-picker.vue";
import { confirm } from "devextreme/ui/dialog";
import { DxSwitch } from "devextreme-vue/switch";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import { DxToast } from "devextreme-vue/toast";
import notify from "devextreme/ui/notify";

export default {
  components: {
    R3Title,
    /* eslint-disable-next-line */
    R3GraphHistoryInjection,
    /* eslint-disable-next-line */
    R3GraphHistoryVolume,
    /* eslint-disable-next-line */
    R3GraphHistoryFill,
    // R3GraphHistoryFillX,
    DxExport,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxColumnChooser,
    DxButton,
    DxStateStoring,
    DxButtonGroup,
    DxBox,
    DxItem,
    DateRangePicker,
    // DxSwitch,
    DxLoadPanel,
    DxToast,
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      dataGridInstance: null,
      currentMode: "widget",
      containerName: "-",
      containerDownhole: "-",
      currentContainer: [],
      currentProperties: [],
      currentHistoryType: 90,
      properties: [],
      currentHistory: [],
      isOperator: false,
      user: null,
      rangeGroup: [
        {
          range: "14",
          text: "14 days",
        },
        {
          range: "30",
          text: "30",
        },
        {
          range: "60",
          text: "60",
        },
        {
          range: "90",
          text: "90",
        },
        {
          range: "custom",
          text: "Custom",
        },
      ],
      rangeDays: 30,
      customDateRange: {
        start: null,
        end: null,
      },
      isCustomRange: false,
      volViewDetail: false,
      showPicker: false,
      loading: true,
      loadingVisible: false,
      toastVisible: false,
      toastMessage: "",
      toastType: "info",
      toastPosition: {
        at: "bottom",
        my: "top",
        of: "#pwreset",
      },
    };
  },
  computed: {
    currentRecordId() {
      return parseInt(
        this.$route.path.substring(this.$route.path.lastIndexOf("/") + 1)
      );
    },
    containers() {
      return this.$store.getters["containers/getContainerHistory"];
    },
    containerHistoryExtended() {
      return this.$store.getters["containers/getContainerExtendedHistory"];
    },
    containerHistoryExtended_Fill() {
      var data = this.$store.getters["containers/getContainerExtendedHistory"];
      var propFill = this.properties.find((x) => x.propertyName == "Fill");
      return data.filter((x) => x.propertyId == propFill.propertyId);
    },
    containerVolumeHistory() {
      var data = this.$store.getters["containers/getContainerHistory"];
      const volumeHist = [];
      var dateCriteria = new Date();
      dateCriteria.setDate(dateCriteria.getDate() - this.currentHistoryType);

      for (const key in data) {
        if (
          data[key].propertyName === "Volume (L)" &&
          data[key].historyDate >= dateCriteria
        ) {
          // if (data[key].propertyName==="Volume (L)")
          const hist = {
            historyId: data[key].historyId,
            customerId: data[key].customerId,
            containerId: data[key].containerId,
            containerName: data[key].containerName,
            propertyId: data[key].propertyId,
            // historyDate: Date.parse(data[key].historyDate),
            // historyDate: data[key].historyDate,
            // historyDate: data[key].historyDate.getFullYear() + "-" + (data[key].historyDate.getMonth() + 1) + "-" + data[key].historyDate.getDate(),
            historyDate:
              data[key].historyDate.getFullYear() +
              "-" +
              ("0" + (data[key].historyDate.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + data[key].historyDate.getDate()).slice(-2),
            propValue: parseFloat(data[key].propValue),
            historyType: data[key].historyType,
            notes: data[key].notes,
            propertyName: data[key].propertyName,
          };
          volumeHist.push(hist);
        }
      }
      return volumeHist;
    },
    subtitle() {
      const headerprops = this.$store.getters["properties/getHeaderProperties"];
      var st = "<div>";
      for (let i = 0; i < headerprops.length; i++) {
        st += headerprops[i].propertyName + ': ' + this.currentContainer[headerprops[i].propertyName] + '</div><div>';
      }
      st+='</div>'
      return st;
    },
  },
  methods: {
    customizeTooltip(pointInfo) {
      return {
        html: `
          <div>
            <div style="width: 100px;padding:5px;text-align: center;"><span style="font-size:18px;font-weight:bold;">${pointInfo.value} L</span></div>
            <div style="width: 100px;padding:5px;text-align: center;">${pointInfo.argumentText}</div>
          </div>`,
      };
    },
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    getPropertyVal(propName) {
      let retVal = "-";
      // console.log(this.currentHistory);
      if (
        this.containers[0].containerName !== undefined &&
        this.containers[0].containerName !== null
      ) {
        //console.log ("PROP", this.currentHistory[this.currentHistory.length-1][propName])
        retVal = this.currentHistory[this.currentHistory.length - 1][propName];
      }
      return retVal;
    },
    parseContainerHistory() {
      const history = [];
      var dateToday = new Date();
      var dateCriteria = new Date();
      dateCriteria.setDate(dateToday.getDate() - this.rangeDays);
      
      // get history data and map a string date onto the object array
      const data = this.$store.getters["containers/getContainerHistory"].map(item => {
        return { ...item, 
          stringDate: item.historyDate.getFullYear() +
          "-" +
          ("0" + (item.historyDate.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + item.historyDate.getDate()).slice(-2),
          unixDate: Date.parse(item.historyDate.getFullYear() +
          "-" +
          ("0" + (item.historyDate.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + item.historyDate.getDate()).slice(-2))
        }; 
      });
      
      while (dateCriteria <= new Date()) {
        const date = dateCriteria.getFullYear() +
            "-" +
            ("0" + (dateCriteria.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + dateCriteria.getDate()).slice(-2)

        const h = {
          containerId: this.currentRecordId,
          containerName: this.currentContainer.containerName,
          historyDate: date,
          historyDateUnix: Date.parse(date)
        };

        const dateData = data.filter((data) => data.unixDate == Date.parse(date))
        if (dateData.length>0)
        {
          for (const key in dateData) {
            const prop = dateData[key].propertyName
            const val = dateData[key].propValue
            h[prop] = val
          }
          history.push(h);
        }
        
        dateCriteria.setDate(dateCriteria.getDate() + 1);
      }
      this.currentHistory = history;
    },
    updateHistType(e) {
      this.currentHistoryType = e.value;
    },
    refreshData() {
      this.loadPageData();
    },
    gotoDetail() {
      this.$router.push({
        name: "reporting-containers-status-details",
        params: { id: this.currentRecordId },
      });
    },
    async loadPageData(refresh = false) {
      this.loading = true;
      try {
        if (this.currentRecordId != null && this.currentRecordId !== undefined && this.currentRecordId > 0) {
          await this.$store.dispatch("containers/clearContainerHistory");
          await Promise.all([
            this.$store.dispatch("containers/loadContainerStatus", this.currentRecordId),
            this.$store.dispatch("containers/loadContainerHistory", this.currentRecordId),
            this.$store.dispatch("containers/loadContainerHistoryDetail", this.currentRecordId),
            this.$store.dispatch("containers/loadContainerHistoryExtended", this.currentRecordId),
            this.$store.dispatch("properties/loadProperties"),
            this.$store.dispatch("users/loadProfile")
          ])
        }
        this.user = this.$store.getters["users/getProfile"];
        this.isOperator = this.user.defaultView?.toLowerCase() == 'operator';
        this.currentContainer = this.$store.getters["containers/getContainerStatus"];
        this.properties = this.$store.getters["properties/getProperties"];
        this.parseContainerHistory();

        // console.log("LOAD.currentContainer", this.currentContainer)
        // console.log("LOAD.properties", this.properties)
        // console.log("LOAD.currentHistory", this.currentHistory)
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
      }
    },
    rangeDaysChange(e) {
      if (e.itemData.range === "custom") {
        this.showPicker = true;
        this.isCustomRange = true;
      } else {
        if (this.isCustomRange) {
          this.refreshData();
          this.isCustomRange = false;
        }
        this.showPicker = false;
        this.customDateRange.start = null;
        this.customDateRange.end = null;
        this.rangeDays = e.itemData.range;
      }
    },
    async applyCustomDateRange() {
      const fromDate = new Date(this.customDateRange.start);
      const today = new Date();
      const diffTime = Math.abs(today - fromDate);
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays > 90) {
        confirm(
          `<div style="text-align: center;">
            <b>The selected date range is greater than 90 days and may take a while to load. Do you want to continue?</b>
          </div>`,
          "Continue?"
        ).then(async (confirmed) => {
          if (confirmed) {
            await this.loadContainterHistoryWithCustomDateRange(diffDays);
          }
        });
      }
      else {
        await this.loadContainterHistoryWithCustomDateRange(diffDays);
      }
    },
    async loadContainterHistoryWithCustomDateRange(diffDays) {
      this.loadingVisible = true;
      this.rangeDays = diffDays;
      await this.$store.dispatch("containers/loadContainerHistory", {
        containerId: this.currentRecordId,
        fromDate: this.customDateRange.start,
        toDate: this.customDateRange.end,
      });
      //await this.$store.dispatch("containers/loadContainerHistoryDetail", {
      //  containerId: this.currentRecordId,
      //  fromDate: this.customDateRange.start,
      //  toDate: this.customDateRange.end,
      //});
      this.parseContainerHistory();
      this.loadingVisible = false;
    },
    handleInvalidRange(message = "End date must be after start date") {
      this.popNotification(message, "warning");
    },
    popNotification(msg, type) {
      //types ['error', 'info', 'success', 'warning']
      const position = "center";
      const direction = "down-stack";
      notify(
        {
          message: msg,
          type: type,
        },
        {
          position,
          direction,
        }
      );
    },
  },
};
</script>

<style scoped>
.tb {
  margin: 40px 0 0 0;
}

.menubar {
  padding: 0 60px 0 60px;
}

.apply-button {
  margin-top: 6%;
}
</style>
